export const filesystemMessages = {
  "directoryBrowser.defaultDescription": "Browse folders under the configured workspace root.",
  "directoryBrowser.close": "Close",
  "directoryBrowser.currentFolder": "Select folder or enter path",
  "directoryBrowser.currentFolder.inputAriaLabel": "Folder path",
  "directoryBrowser.currentFolder.inputPlaceholder": "Type or paste a folder path",
  "directoryBrowser.openCurrent": "Open",
  "directoryBrowser.goTo": "Go to a folder",
  "directoryBrowser.goToTypedPath": "Go to this folder",
  "directoryBrowser.goToParent": "Parent folder",
  "directoryBrowser.goToHome": "Home",
  "directoryBrowser.goToRoot": "Workspace root",
  "directoryBrowser.goToInitial": "Back to {name}",
  "directoryBrowser.selectCurrent": "Select Current",
  "directoryBrowser.newFolder": "New Folder",
  "directoryBrowser.creating": "Creating…",
  "directoryBrowser.loadingFolders": "Loading folders…",
  "directoryBrowser.noFolders": "No folders available.",
  "directoryBrowser.upOneLevel": "Up one level",
  "directoryBrowser.select": "Select",
  "directoryBrowser.load.errorFallback": "Unable to load filesystem",
  "directoryBrowser.createFolder.promptMessage": "Create a new folder in the current directory.",
  "directoryBrowser.createFolder.title": "New Folder",
  "directoryBrowser.createFolder.inputLabel": "Folder name",
  "directoryBrowser.createFolder.inputPlaceholder": "e.g. my-new-project",
  "directoryBrowser.createFolder.confirmLabel": "Create",
  "directoryBrowser.createFolder.cancelLabel": "Cancel",
  "directoryBrowser.createFolder.invalidNameMessage": "Please enter a single folder name.",
  "directoryBrowser.createFolder.invalidNameDetail": "Folder names cannot include slashes, '..', or '~'.",
  "directoryBrowser.createFolder.errorFallback": "Unable to create folder",

  "filesystemBrowser.descriptionFallback": "Search for a path under the configured workspace root.",
  "filesystemBrowser.rootLabel": "Root: {root}",
  "filesystemBrowser.actions.close": "Close",
  "filesystemBrowser.actions.retry": "Retry",
  "filesystemBrowser.actions.select": "Select",
  "filesystemBrowser.filterLabel": "Filter",
  "filesystemBrowser.search.placeholder.directories": "Search for folders",
  "filesystemBrowser.search.placeholder.files": "Search for files",
  "filesystemBrowser.currentFolder.label": "Current folder",
  "filesystemBrowser.currentFolder.selectCurrent": "Select Current",
  "filesystemBrowser.loading.filesystem": "filesystem",
  "filesystemBrowser.loading.workspaceRoot": "workspace root",
  "filesystemBrowser.loading.loadingWithPath": "Loading {path}…",
  "filesystemBrowser.empty.noEntries": "No entries found.",
  "filesystemBrowser.navigation.upOneLevel": "Up one level",
  "filesystemBrowser.hints.navigate": "Navigate",
  "filesystemBrowser.hints.select": "Select",
  "filesystemBrowser.hints.close": "Close",
  "filesystemBrowser.errors.loadFilesystemFallback": "Unable to load filesystem",
  "filesystemBrowser.errors.openDirectoryFallback": "Unable to open directory",
} as const
